import { render, staticRenderFns } from "./datEmbededViewComplaintDetail.vue?vue&type=template&id=a7a217c2"
import script from "./datEmbededViewComplaintDetail.vue?vue&type=script&lang=js"
export * from "./datEmbededViewComplaintDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports